const cookie = {
  get(key) {
    const v = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  },
  // maxAge in days
  set(key, value, maxAge = 1, expireDate = '') {
    if (key && value) {
      document.cookie = `${key}=${value}; ${
        expireDate
          ? `expires=${new Date(expireDate).toGMTString()};`
          : `max-age=${60 * 60 * 24 * maxAge};`
      }`;

      // check if cookie was successfully set to browser
      return this.get(key) === value;
    }

    return false;
  },
};

export const COOKIE_NAMES = {
  noCheckoutRequired: 'fff_edit_noCheckoutRequired_modal',
  sessionId: 'sessionId',
  boostsSubscriptionModal: 'fff_boostsSubscriptionModal',
};

export default cookie;
